import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useFlagImageMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ propertyId: e, imageId: t, reason: n }) => r.flagImage(e, t, { reason: n }),
		onSuccess: (t, { propertyId: n }) => {
			i.invalidateQueries({ queryKey: e.images(n) });
		}
	});
};
//#endregion
export { i as useFlagImageMutation };
